import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from "vuex-persist";
Vue.use(Vuex);
const vuexPersist = new VuexPersistence({
  key: "CRD"
});

export default new Vuex.Store<any>({
  plugins: [vuexPersist.plugin],
  state: {
    sessLoginData: null,
    currentLang: null,
    userNav: true,
    walletPopUp: false,
    login: false,
    superInitData: null,
    transInfo: null,
    staticData:null,
    tabKey:null,
    requestModule:'',
    manageUser:null
  },
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
    updateSessLoginData(state,data){
      state.sessLoginData=data;
    },
    updateRequestModule(state,data){
      state.requestModule=data;
    },
    updateTabKey(state,data){
      state.tabKey=data;
    },
    updateStaticData(state,data){
      state.staticData=data;
    },
    updateIsLogin(state,data){
      state.login=data;
    },
    updateSuperInitData(state,data){
      state.superInitData=data;
    },
    updateUserNavData(state,data){
      state.userNav=data;
    },
    updateTransInfo(state,data){
      state.transInfo=data;
    },
    updateManageUser(state,data) {
      state.manageUser = data;
    }
  },
  actions: {
    updateSessLoginDataAc(context, payload) {
      context.commit('updateSessLoginData', payload)
    },
    updateRequestModuleAc(context, payload) {
      context.commit('updateRequestModule', payload)
    },
    updateTabKeyAc(context, payload) {
      context.commit('updateTabKey', payload)
    },
    updateStaticDataAc(context, payload) {
      context.commit('updateStaticData', payload)
    },
    updateIsLoginAc(context, payload) {
      context.commit('updateIsLogin', payload)
    },
    updateSuperInitDataAc(context,payload){
      context.commit('updateSuperInitData',payload);
    },
    updateUserNavDataAc(context,payload){
      context.commit('updateUserNavData',payload);
    },
    updateTransInfoAc(context,payload){
      context.commit('updateTransInfo',payload);
    }, 
    updateManageUserAc(context,payload) {
      context.commit('updateManageUser',payload);
    }
  },
  getters:{
    sessLoginDataGet:state=>state.sessLoginData,
    isLoginGet:state=>state.login,
    updateSuperInitDataGet:state=>state.superInitData,
    userNavDataGet:state=>state.userNav,
    transInfoGet:state=>state.transInfo,
    staticDataGet:state=>state.staticData,
    tabKeyGet:state=>state.tabKey,
    requestModuleGet:state=>state.requestModule,
    manageUserGet: state=>state.manageUser
  }
});
